import { reactive, readonly } from 'vue'

const state = reactive({
  env: undefined,
  timezone: undefined,
  url: undefined,
  name: undefined,
  local: undefined,
  maintenance: undefined,
  version: undefined,
})

const methods = {
  getEnv() {
    return state.env
  },
  setEnv(env) {
    state.env = env
  },
  getTimezone() {
    return state.timezone
  },
  setTimezone(timezone) {
    state.timezone = timezone
  },
  getURL() {
    return state.url
  },
  setURL(url) {
    state.url = url
  },
  getName() {
    return state.name
  },
  setName(name) {
    state.name = name
  },
  getLocale() {
    return state.locale
  },
  setLocale(locale) {
    state.locale = locale
  },
  getVersion() {
    return state.version
  },
  setVersion(version) {
    state.version = version
  },
  getMaintenance() {
    return state.maintenance
  },
  setMaintenance(maintenance) {
    state.maintenance = maintenance
  },
}

export default {
  name: 'AppConfigStore',
  state: readonly(state),
  methods,
}
